import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../../../environments/environment';
import * as HttpStatus from 'http-status-codes';

@Injectable()
export class EquipmentCreateService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  public create(post): Observable<any> {
    const url = this.urlPrefix + 'equipments/static';
    return this.http
      .post(url, {
        siteId: post.siteId.value[0].id,
        productCategoryId: post.productCategory.value[0].id,
        brand: post.brand.value,
        model: post.model.value,
        designationNumber: post.designationId.value,
        productName: post.productName.value,
        serialNumber: post.serialNumber.value,
        description: post.description.value,
        type: post.type.value,
        ratingOrCapacity: post.rating.value,
        forms: post.formIds.value.map((f) => {
          return { 
          formId: f.id
        }
        })
        // remarks: post.remarks.value
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === HttpStatus.CREATED) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-create/equipment-create.service.ts